export default {
  home: {
    describe1: "Добро пожаловать на сайт",
    describe2: "Создайте мир на расстоянии вытянутой руки",
    describe3: "Благодаря совершенным кроссплатформенным решениям, он основан на сетевой платформе и использует технологию распределенного регионального управления, которая позволяет эффективно интегрировать различные мультимедийные ресурсы и обеспечивать удаленное производство, выпуск и управление программами."
  },
  app: {
    more: "Посмотреть еще",
    LogOut: "выход из системы",
    AddMaterial: "Дополнительный материал",
    CreateRelease: "Создайте, пожалуйста",
    AddTerminal: "Добавьте терминал",
    CreateAccount: "Создайте учетную запись",
    Percent: "Процент",
    ReleaseSchedule: "График выпуска",
    retransmission: "Rtns-соединения",
    AllRetransmission: "Все ссылки",
    ClearanceToComplete: "Очистить полностью",
    RemoveAll: "Удалить все"
  },
  basics: {
    Cancel: "отменять",
    Confirm: "определять",
    en: "английский язык",
    zh: "китайский язык",
    PleaseSelect: "Пожалуйста выберите",
    PleaseInput: "Пожалуйста, введите",
    materialCatalogue: "Каталог материалов",
    structureGrouping: "Организационная структура разбита на группы"
  },
  public: {
    search: "Пожалуйста, введите ключевые слова для запроса"
  },
  router: {
    help: "Помогите",
    material: "Управление материалами",
    programme: "Управление программой",
    editProgramme: "Редактирование программы",
    publishProgramme: "Публикация программы",
    terminal: "Управление терминалом",
    check: "Контрольный контроль",
    log: "Управление журналом",
    logLogin: "Вход в систему",
    logOperation: "Вход в систему управления",
    logTerminal: "ЛогТерминал",
    seniorManagement: "Высшее руководство",
    userManage: "Управление пользователями",
    RoleManage: "Управление ролями",
    systemLayout: "Системное описание",
    nodeManage: "Управление узлами",
    reviewSet: "Набор обзоров",
    softwareLicence: "Лицензия на программное обеспечение"
  },
  device: {},
  explorer: {
    clickUpload: "Перетащите файлы сюда или нажмите, чтобы загрузить",
    sizeLimit: "размер одного файла не должен превышать",
    video: "видео",
    picture: "картинка",
    uploadFiles: "Загрузить файл",
    newFolder: "Создайте новую папку",
    deleteFiles: "Удалить файлы",
    materialAll: "Все материалы загружены",
    materialsLoaded: "Нажмите, чтобы загрузить материал",
    move: "двигаться",
    copy: "копировать",
    delete: "стирать",
    all: "Выбрать все",
    name: "название",
    resolution: "разрешение",
    fileSize: "Размер файла",
    creationTime: "Время создания",
    operate: "работать",
    FolderName: "Имя папки",
    deleteFile: "ЕСЛИ удалить выбранный в данный момент файл?",
    BackEdit: "Вернемся к редактированию программы",
    FileMove: "Перемещение файлов",
    FileCopy: "Копия файла",
    StartAll: "Все начинается",
    StopAll: "Остановить все",
    EmptyFinish: "Опорожнение завершено",
    CancelAll: "Отменить все",
    NoFiles: "Пока нет загруженных файлов",
    Status: "состояние",
    Check: "проверить",
    Stop: "остановка",
    Start: "Начать",
    Cancel: "отменять",
    finish: "закончить"
  },
  log: {
    export: "экспорт",
    selectDevice: "Выберите оборудование",
    deviceSn: "Оборудование SN",
    operateTime: "Время работы",
    operateUser: "Действующий пользователь",
    function: "функция",
    describe: "описание",
    dateArr: "Диапазон дат",
    startDate: "Дата начала",
    endDate: "Дата окончания",
    search: "запроса",
    searchTips: "Пожалуйста, выберите устройство для запроса",
    loadingTips: "Журнал получен, пожалуйста, подождите",
    no: "серийный номер",
    content: "содержание",
    operateObj: "Объект операции",
    operateContent: "Информация о работе",
    selectTips1: "Поддержка запроса данных осуществляется только в течение трех месяцев",
    searchTips1: "Пожалуйста, сначала выберите терминал, определите диапазон времени и отправьте запрос",
    exportTips: "Экспортировать можно только данные, находящиеся в пределах временного диапазона запроса"
  },
  login: {
    Login: "Авторизоваться",
    memberRegister: "Регистрация участника",
    ForgetThePassword: "Забыли пароль?",
    NoLogin: "Не заходите в систему в течение семи дней",
    verification: "Пожалуйста, введите проверочный код",
    account: "Пожалуйста, войдите в свою учетную запись",
    password: "Пожалуйста, введите пароль"
  },
  manage: {},
  review: {
    Screenshot: "скриншот",
    ProgramName: "Название программы",
    Structure: "структура",
    Resolution: "разрешение",
    CreationTime: "Время создания",
    operate: "работать",
    Review: "аудит",
    Check: "проверить",
    ProgramMaterial: "Программный материал",
    ProgramPreview: "Предварительный просмотр программы",
    ReviewContent: "Пожалуйста, ознакомьтесь с содержанием обзора",
    Approved: "Прошел аудит",
    RejectReview: "Отказываются проходить",
    DeleteAll: "Подтверждаете удаление всех?",
    Name: "название",
    Size: "Размер",
    Preview: "Предварительный просмотр",
    ProgramReview: "Обзор программы",
    ReasonRefusal: "Пожалуйста, укажите причину отказа!",
    number: "Номер регистрационного талона не указан",
    review: "аудит",
    enterKey: "Пожалуйста, введите ключевые слова",
    screenshot: "скриншот",
    name: "название",
    group: "агентство",
    createTime: "Время подачи заявки",
    publisher: "Издатель",
    check: "проверить",
    pass: "Пройденный",
    reject: "отвергать",
    materialCheck: "Обзор материалов",
    pleaseInputContent: "Пожалуйста, ознакомьтесь с содержанием обзора",
    approve: "Прошел аудит",
    rejectReview: "Отклонить отзыв",
    releaseReview: "Обзор выпуска",
    resonForReject: "Пожалуйста, укажите причину отказа",
    all: "все",
    waitReview: "Подлежит пересмотру",
    approves: "пройти",
    selectTips: "Пожалуйста, выберите хотя бы один материал",
    selectTips1: "Поддерживает запрос данных только в течение трех месяцев",
    deleteTips: "Подтверждаете все удаления?",
    deleteRecord: "Удалить записи",
    singleNo: "Номер заказа",
    loop: "цикл",
    timming: "синхронизация",
    instream: "Интерстициальный",
    noAdap: "Не адаптивный",
    adap: "Адаптивный размер экрана"
  },
  schedule: {
    Screenshot: "скриншот",
    ProgramName: "Название программы",
    Structure: "структура",
    Resolution: "разрешение",
    CreationTime: "Время создания",
    operate: "работать",
    AllLoaded: "Все загружено",
    materialsLoaded: "Нажмите, чтобы загрузить материал",
    NewProgram: "Новая программа+",
    DelProgram: "Вы хотите безвозвратно удалить выбранную в данный момент программу?",
    DeleteMedia: "Удаление носителя",
    loop: "Воспроизведение в цикле",
    timpingPlay: "Синхронизированное воспроизведение",
    emerPlay: "Экстренный интерстициальный",
    releaseRecord: "Запись о выпуске",
    releaseMan: "Управление выпуском",
    playNo: "Номер выпуска",
    group: "агентство",
    releaseType: "Тип выпуска",
    releaseNow: "Отпусти сейчас же",
    releaseTim: "Время выхода",
    publisher: "Издатель",
    review: "аудит",
    pedReview: "Подлежит пересмотру",
    noReview: "Нет отзыва",
    noPass: "Не проходите мимо",
    pass: "Пройденный",
    waitRelease: "Быть освобожденным",
    expird: "Истекший",
    detail: "подробности",
    delete: "стирать",
    deletePlay: "Удалить программу",
    deletePlayTip: "Вы хотите безвозвратно удалить выбранную в данный момент программу?",
    keyWords: "Пожалуйста, введите ключевые слова",
    noSelectTip: "Ни одна запись выпуска не была выбрана",
    addPlay: "Добавить программу",
    selectProgram: "Выберите список программ",
    delPro: "Удалить программу",
    delProTip: "Вы хотите удалить все программы?",
    screenshot: "скриншот",
    proName: "Название списка программ",
    structure: "структура",
    resolution: "разрешение",
    createTime: "Время создания",
    noProgram: "В настоящее время никаких программ не существует",
    moveDown: "Больше не могу двигаться вниз",
    moveUp: "Больше не могу двигаться вверх",
    tips: "подсказка",
    playList: "список воспроизведения",
    terminalList: "Список терминалов",
    releaseProp: "Публиковать атрибуты",
    offline: "не в сети",
    timimgPlan: "Своевременный выпуск",
    user: "Пользователь",
    terminalName: "Название терминала",
    terminalState: "Состояние устройства",
    publishSate: "Статус выпуска",
    planModole: "Режим воспроизведения",
    playStrategy: "Стратегия выпуска",
    playPlan: "План игры",
    playCount: "Количество воспроизведений",
    playsCount: "Количество последовательных воспроизведений",
    pleaseSelect: "Пожалуйста выберите",
    playTimes: "Время игры",
    conPlayTime: "Время непрерывного воспроизведения",
    publish: "сообщать",
    customize: "настроить",
    once: "один раз",
    twice: "два раза",
    treeTimes: "три раза",
    fourTimes: "четыре раза",
    fiveTimes: "пять раз",
    sixTimes: "шесть раз",
    sevenTimes: "семь раз",
    eightTimes: "восемь раз",
    nineTimes: "девять раз",
    tenTimes: "десять раз",
    countTips: "Минимальное количество раз - 1",
    pubSuccessTip: "Успешно выпущенный",
    selectTip1: "Пожалуйста, выберите как минимум две программы",
    planPre: "Предварительный просмотр программы",
    addPlayStep: "Добавьте шаги планирования",
    selectDate: "Выберите дату и время",
    instreamResver: "Запишитесь на прием в интерстициальный",
    instreamNow: "Вставьте сейчас",
    selectTimeTips: "Выбранное время не может быть меньше текущего",
    palyTime: "Время игры",
    selectStartTime: "Выберите время начала",
    selectEndTime: "Выберите время окончания",
    conserLoop: "Количество последовательных циклов",
    validDate: "Дата вступления в силу",
    date: "дата",
    daily: "каждый день",
    startTimeTips: "Время начала не может быть позже времени окончания",
    endTimeTips: "Время окончания не может быть раньше времени начала",
    startDateTips: "Дата начала не может быть позже даты окончания",
    endDateTips: "Дата окончания не может быть ранее даты начала",
    saveAplan: "Придерживайтесь хотя бы одного плана",
    check: "проверить",
    planSize: "Размер программы",
    planName: "Название выпуска",
    leastTime: "Срок годности"
  },
  system: {
    StructureName: "Название организационной структуры",
    Operate: "работать",
    NewStructure: "Новая организационная структура",
    DeleteStructure: "Удалить организационную структуру",
    Structure: "структура",
    MsgDeleteStructure: "Вы хотите удалить текущий файл навсегда?",
    OnDevice: "Включить устройство",
    OffDevice: "Выключить устройство",
    inquiry: "ПРИ",
    on: "включении",
    off: "выключите",
    slaveDevice: "текущее или ведомое устройство",
    CloseCurrent: "Закрыть текущее",
    CloseSlave: "Закрыть ведомое",
    OpenCurrent: "Открыть текущее",
    OpenSlave: "Открыть ведомое",
    Account: "счет",
    Name: "полное имя",
    Role: "роль",
    Grade: "уровень",
    Remark: "Замечания",
    RoleName: "Имя персонажа",
    Password: "код",
    ConfirmPass: "Подтвердите пароль",
    Mail: "электронная почта",
    DeleteUser: "Удалить пользователя",
    DeleteRole: "Удалить текущую роль навсегда",
    UnblockDevice: "Разблокировать устройство",
    banDevice: "Заблокировать устройство",
    Unblock: "Разблокировать",
    ban: "Запрещенный",
    BanTheCurrent: "Заблокировать текущего участника",
    BannedAffiliate: "Заблокированный партнер",
    ReleaseTheCurrent: "Освободить текущего участника",
    ReleaseTheSubordinate: "Освободить подчиненного",
    AddUser: "Новые пользователи",
    ModifyUser: "Изменить пользователя",
    inputPassword: "Пожалуйста, введите пароль для подтверждения",
    noPassword: "Пароли, введенные дважды, не совпадают!",
    inputName: "Пожалуйста, введите свое имя",
    RoleEmpty: "Имя роли не может быть пустым",
    StructureEmpty: "Имя структуры не может быть пустым",
    AccountEmpty: "Учетная запись не должна быть пустой",
    AccountAstrict: "Учетная запись содержит только цифры, буквы и символы подчеркивания!",
    AccountLength: "Пожалуйста, укажите длину учетной записи от 3 до 20 символов!!",
    AccountRegistered: "Текущая учетная запись была зарегистрирована, пожалуйста, войдите повторно!",
    AddRole: "Новая роль",
    RoleRemark: "Замечания о персонаже",
    RightConfig: "Правильная конфигурация",
    DelRole: "Удалить роль",
    imageSize1: "Рекомендуется использовать изображение в формате PNG размером 920х940 пикселей",
    ReplacePicture: "Заменить изображение",
    LoginLogo: "ЛОГОТИП страницы входа в систему",
    imageSize2: "Рекомендуются изображения в формате PNG с рекомендуемым размером 360x80 пикселей",
    SystemLogo: "ЛОГОТИП системной страницы",
    systemSettings: "Другие системные настройки",
    configInformation: "Другая информация о конфигурации",
    DailyLimit: "Дневной лимит применения",
    UploadedType: "Загруженное изображение аватара может быть только в формате PNG!",
    UploadedSize: "Размер загруженного изображения аватара не может превышать 2 МБ!",
    addNode: "Добавить узел",
    EnglishName: "Английское имя",
    ChineseName: "Китайское имя",
    delNode: "Окончательно удалить текущую роль?",
    AuthorizationType: "Тип кода авторизации",
    Model: "модель",
    Date: "дата",
    AuthorizationCode: "код авторизации",
    clearTips1: "Удалять ли всех текущих рецензентов?",
    clearTips2: "Удалять ли текущего рецензента?",
    selectReviewer: "Выберите аудиторов",
    noReviers: "Персонал, не имеющий соответствующих аудиторских полномочий",
    createTips: "Пожалуйста, сначала создайте учетную запись аудита",
    sameReviwers: "В следующей организации используется тот же самый аудитор",
    email: "электронная почта",
    phone: "телефон",
    lastLogin: "Последний вход в систему",
    remark2: "Адрес компании",
    resetPwd: "Сброс пароля",
    subUser: "Подчиненные пользователи",
    NumOfTerminals: "Количество терминалов",
    NumOfPro: "Количество программ",
    editPwd: "Поменять пароль",
    oriPwd: "Оригинальный пароль",
    newPwd: "Установите новый пароль",
    confirmPws: "Определите пароль",
    modifyInfo: "Изменять информацию",
    changeNick: "Изменить псевдоним",
    changeEmail: "Изменить почтовый ящик",
    personalCenter: "Личный центр",
    enterOriPwd: "Пожалуйста, введите исходный пароль",
    enterNewPwd: "Пожалуйста, введите новый пароль",
    confirmPwd: "Пожалуйста, подтвердите пароль",
    enterNick: "Пожалуйста, введите свой ник",
    pwdNoPass: "Пароль дважды не согласован",
    changePwdSucc: "Пароль был успешно изменен",
    modiSuccess: "Успешно изменен",
    modiFail: "Не удалось выполнить модификацию",
    noSet: "Не установлен",
    PleaseInputEmail: "Пожалуйста, введите адрес электронной почты"
  },
  terminal: {
    treeTitle: "Группировка организационной структуры",
    Details: "подробности",
    online: "онлайн",
    offline: "не в сети",
    list: "список",
    card: "график",
    map: "карта",
    keyWord: "Пожалуйста, введите ключевые слова",
    refresh: "обновлять",
    add: "добавить",
    delete: "стирать",
    deviceName: "Имя устройства",
    remark: "Замечания",
    resolution: "разрешение",
    types: "тип",
    version: "Номер версии",
    status: "состояние",
    operate: "работать",
    edit: "изменять",
    loading: "Отчаянно загружаясь",
    allSelect: "Выберите все страницы подряд",
    selected: "Выбранный",
    selectAll: "Выберите все на этой странице",
    selectInMap: "Пожалуйста, выберите местоположение устройства на карте",
    structure: "структура",
    selectGroup: "Пожалуйста, выберите организационную структуру",
    selectSize: "Выберите разрешение",
    customize: "настроить",
    followTerminal: "Следовать за терминалом",
    selectSn: "Пожалуйста, выберите SN",
    deviceTip: "Имя устройства не может быть пустым",
    snTip: "SN не может быть пустым",
    sizeTip: "Разрешение экрана не может быть пустым",
    deviceType: "Тип устройства",
    cancel: "отменять",
    confirm: "уверенный",
    delDevice: "Удалить терминал",
    delDevTip: "Вы хотите удалить выбранный терминал навсегда?",
    onlineTotal: "Онлайн-статистика",
    reboot: "возобновлять",
    offscreen: "Выключите экран",
    onscreen: "Открытый экран",
    timeTask: "Команда синхронизации",
    conBright: "Регулировка яркости",
    conVoice: "Регулировка звука",
    relay: "Релейный выключатель",
    timeZone: "Калибровка часового пояса",
    signalChange: "Переключение сигналов",
    synScreen: "Многоэкранная синхронизация",
    timePlay: "Переключатель времени воспроизведения",
    timeOn: "Переключатель таймера",
    wTip: "Разрешение W пустое",
    hTip: "Разрешение H пустое",
    xTip: "Позиция X пуста",
    yTip: "Позиция Y пуста",
    mapTip: "Уменьшите масштаб на карте, чтобы ознакомиться с информацией в таблице! ! !",
    selectTip: "Устройство не выбрано",
    deviceDetail: "Детали оборудования",
    playList: "список воспроизведения",
    affi: "Присоединение:",
    screenType: "Тип экрана",
    boxTime: "Часы-шкатулка",
    noData: "Нет доступных данных",
    currTimeZone: "Текущий часовой пояс",
    deviceLan: "Язык устройства",
    deviceZoom: "Объем памяти",
    runState: "Рабочее состояние",
    runTime: "Непрерывная работа",
    lastHeart: "Недавнее сердцебиение",
    timeOrder: "Команда синхронизации",
    comAddr: "Адрес сервера",
    voice: "голос",
    birght: "яркость",
    no: "серийный номер",
    proName: "Название программы",
    power: "реле",
    milRefresh: "Автоматическое обновление за считанные секунды",
    viewPho: "Просмотр исходного изображения",
    setTimeZone: "Установите часовой пояс",
    terminalUp: "Модернизация терминала",
    upType: "Способ обновления",
    cloudUp: "Обновление в облаке",
    localUp: "Обновление локального файла",
    clickUp: "Нажмите кнопку загрузить",
    name: "название",
    type: "модель",
    verInfo: "Информация о версии",
    schedule: "прогресс",
    noUp: "Нет необходимости в обновлении",
    waitStar: "Ожидание начала",
    downExc: "Исключение для загрузки",
    downOK: "Успешная загрузка",
    upTip: "После завершения обновления он автоматически перезапустится",
    erroBack: "Ненормальная обратная связь",
    downError: "Ошибка загрузки",
    dowNum: "1 выбранный",
    upTips1: "Примечание: Чтобы предотвратить потерю данных, пожалуйста, создайте резервную копию данных, устройство автоматически перезагрузится после завершения обновления,",
    upTips2: "пожалуйста, не выключайте питание во время процесса обновления",
    upGr: "обновление",
    serverAddEdit: "Изменение адреса сервера",
    serEdTit: "Перенесите терминал на новый сервер",
    newAddr: "Новый адрес сервера",
    test: "проверка",
    user: "счет",
    psw: "код",
    remove: "миграция",
    conRes: "Подтвердите перезапуск",
    conOnSc: "Подтвердите открытие экрана",
    upTips3: "Пожалуйста, используйте zip-файл или apk-файл",
    testOk: "Прошел тест",
    testFail: "Тест не пройден",
    inputTips1: "Пожалуйста, введите имя пользователя и пароль",
    opOk: "Успешная операция",
    mapTip1: "Пожалуйста, отметьте местоположение устройства на карте",
    addDetail: "Подробный адрес",
    lng: "долгота",
    lat: "Широта",
    matTip2: "Не удалось получить адрес, пожалуйста, повторите попытку позже",
    orderTip: "Подтвердите перезапуск выбранного экрана терминала?",
    orderTip1: "Подтвердите закрытие выбранного экрана терминала?",
    orderTip2: "Подтвердите, чтобы открыть выбранный экран терминала?",
    scSetting: "Настройки планирования",
    selectTip1: "Пожалуйста выберите",
    selectTip2: "Добавлена команда синхронизации",
    selectTip3: "Пожалуйста, выберите данные о работе шаблона",
    conOrder: "Инструкции по эксплуатации",
    action1: "Переключение программ",
    action2: "Регулировка яркости",
    action3: "Регулировка громкости",
    action4: "Выключите экран",
    action5: "Открытый экран",
    action6: "Переключение источника сигнала",
    action7: "Реле выключено",
    action8: "Реле включено",
    action9: "Выключите экран",
    action10: "Включите экран",
    value: "ценность",
    acVa1: "Приоритет HDMI",
    acVa2: "Асинхронный сигнал",
    acVa3: "Сигнал синхронизации",
    excTime: "Время выполнения",
    dateOk: "Дата вступления в силу",
    noLimit: "неограниченный",
    isWeekLi: "Эффективная неделя",
    oper: "работать",
    newTem: "Создать шаблон",
    savTem: "Сохранить шаблон",
    addTem: "добавить шаблон планирования",
    temName: "Имя шаблона",
    temTip1: "Пожалуйста, введите название шаблона",
    relayOn: "Релейный выключатель",
    timeZoneSe: "Выбор часового пояса",
    hdmiSi: "Источник сигнала HDMI",
    inSin: "Внутренний источник сигнала",
    openMulti: "Включение синхронного воспроизведения на нескольких экранах",
    gps: "GPS-синхронизация",
    localW: "Синхронизация по локальной сети",
    closeScreen: "Отключите синхронное воспроизведение на нескольких экранах",
    openTimePlay: "Включите синхронизированное воспроизведение",
    closeTimePlay: "Выключите синхронизированное воспроизведение",
    openTime: "Включите хронометраж",
    onTime: "Время загрузки",
    offTime: "Время выключения",
    excDate: "Дата исполнения",
    closeTime: "Отключите синхронизацию",
    onlyG: "Только вспомогательное оборудование для рекламных машин",
    Sunday: "Воскресенье",
    Monday: "Понедельник",
    Tuesday: "Вторник",
    Wednesday: "Среда",
    Thursday: "Четверг",
    Friday: "Пятница",
    Saturday: "Суббота",
    noDeviceSelected: "Устройство не выбрано",
    group: "Организация",
    onlineNum: "Онлайн-количество",
    offlineNum: "Автономное количество",
    totalNum: "Общее количество оборудования",
    noOrderExc: "Ни одна команда еще не была выполнена",
    createTime: "Время создания",
    orderName: "Имя команды",
    aimDevice: "Целевое устройство",
    orderStatus: "Статус команды",
    timeOut: "Обратная связь по тайм-ауту",
    excSuccess: "Успешное выполнение",
    sent: "Отправлено",
    timeOpenNo: "Переключатель таймера: Данные отсутствуют",
    timeOpen: "Переключатель таймера: включен",
    deviceOff: "Устройство в автономном режиме",
    timeOpenTip: "Включено синхронизированное воспроизведение",
    timeCloseTip: "Воспроизведение по времени отключено",
    programList: "Список программ",
    playTime: "Продолжительность программы",
    loop: "Воспроизведение в цикле",
    excSta: "Исполнительный стандарт",
    timingPlay: "Синхронизированное воспроизведение",
    playCount: "Количество воспроизведений",
    proDelete: "Удалить программу",
    proDeleteTip: "Удалить программу?",
    timePlayOpenTip: "Воспроизведение по времени успешно включено",
    timePlayCloseTip: "Воспроизведение по времени успешно отключено",
    programChangeTip: "Успешное переключение программ",
    programIsPlaying: "Шоу продолжается",
    powerList: "Бортовой источник питания",
    allOpen: "Полностью открытый",
    allClose: "Все выключено",
    open: "начать",
    close: "закрывать",
    mulCard: "Многофункциональная карта",
    firstChannel: "Первый способ",
    secondChannel: "Второй способ",
    thirdChannel: "Третий способ",
    fourthChannel: "Четвертый способ",
    fifthChannel: "Пятый способ",
    sixthChannel: "Шестой канал",
    seventhChannel: "Седьмой способ",
    eighthChannel: "Восьмой способ",
    syncToTerminal: "Синхронизация с терминалом",
    allOpenTip: "Подтвердите включение/выключение многофункциональной платы?",
    operComman: "Инструкции по эксплуатации",
    brigValue: "громкость",
    method: "способ",
    speDate: "Укажите дату",
    speWeek: "Назначенная неделя",
    isDateLimit: "Есть ли ограничение по дате?",
    isWeekLimit: "Существует ли недельный лимит?",
    edits: "редактор",
    timingOn: "Включена команда синхронизации",
    timingOff: "Команда синхронизации отключена",
    addTimingCom: "Добавить команду синхронизации",
    ban: "Запрещенный",
    opend: "начать",
    closed: "закрывать",
    timePlayTips: "Синхронизация воспроизведения, не может быть переключена",
    addDevice: "Добавить устройство",
    deviceTypeTip: "Пожалуйста, выберите тип устройства",
    key: "ключ",
    groupTips: "Организационная структура не может быть пустой",
    least: "Все еще оставленный",
    arrangeTip: "Пожалуйста, выберите значение от 0 до 100",
    saveSuccess: "Успешно сохранен",
    tempExit: "Шаблон уже существует, пожалуйста, измените название",
    command: "приказ",
    isSent: "Отправлено по адресу",
    execSuccess: "Успешное выполнение",
    sented: "Отправлено",
    execFail: "Обратная связь по тайм-ауту",
    runStatus: "Онлайн, на экране и в эфире",
    timeLimit: "Пожалуйста, сделайте паузу",
    timeLimitTip: "Секунд, затем выполните операцию, время еще есть",
    seconds: "секунда",
    CentralControl: "Управление центральным управлением",
    EditInstruction: "Редактировать инструкцию",
    AddInstruction: "Добавить инструкцию"
  },
  PE: {
    Setting: "Установка",
    Save: "сохранить",
    Release: "сообщать",
    Quit: "выходить из",
    ExitEditProgram: "Выход приведет к удалению редактируемой в данный момент программы",
    DragMaterial: "Перетащите файл с материалами сюда",
    SaveWait: "Скриншоты и сохранение, пожалуйста, подождите...",
    ProgramList: "Список окон",
    multimedia: "Мультимедиа",
    AddMultimedia: "Добавить мультимедиа",
    Insert: "Вставить в текущее положение",
    properties: "Свойства",
    materialNull: "Пожалуйста, добавьте материал в окно",
    Uploaded: "Закачанный",
    AllLoaded: "Все загружено",
    materialsLoaded: "Нажмите, чтобы загрузить материал",
    Text: "текст",
    Digital: "Цифровые часы",
    Analog: "Аналоговые часы",
    Weather: "погода",
    Timing: "Синхронизация",
    Countdown: "обратный отсчет",
    StreamMedia: "Потоковое мультимедиа",
    RSS: "RSS-канал",
    Window: "окно",
    Picture: "картинка",
    Video: "видео",
    Delete: "стирать",
    Webpage: "Веб-страница",
    OneLayerUp: "Поднимитесь на один уровень выше",
    OneLayerDown: "Следующий уровень",
    Top: "Самый верхний",
    Bottom: "Самый нижний слой",
    Full: "Полноэкранный режим",
    HorizontalFull: "Горизонтальное мощение",
    VerticalFull: "Вертикально покрытый",
    VerticalDown: "Вертикально вниз",
    VerticalMiddle: "Вертикально центрированный",
    VerticalTop: "Вертикально вверх",
    HorizontalLeft: "Горизонтально влево",
    HorizontalCenter: "Центрированный по горизонтали",
    HorizontalRight: "Горизонтально вправо",
    ProgramName: "Название программы",
    Structure: "структура",
    DeviceType: "Тип устройства",
    Resolution: "разрешение",
    CustomResolution: "Пользовательское разрешение",
    Device: "Устройство",
    SelectDevice: "Пожалуйста, выберите устройство",
    SelectTerminal: "Выберите терминал публикации",
    TerminalName: "Название терминала",
    DeviceStatus: "Состояние устройства",
    Offline: "не в сети",
    AdaptiveScreen: "Воспроизведение с учетом размера экрана",
    Tip: "подсказка",
    Thumbnail: "Эскиз",
    Name: "название",
    version: "Номер версии",
    Title: "Заглавие",
    TimerMode: "Временной режим",
    RelativeTime: "Относительное время",
    AbsoluteTime: "Абсолютное время",
    DisplayMode: "Режим отображения",
    Day: "день",
    Hour: "час",
    Minutes: "минута",
    Second: "Второй",
    EditStyle: "Редактировать стиль",
    DisplayUsage: "Редактировать стиль",
    ARow: "Одиночная строка",
    MultiRow: "Несколько строк",
    FontFamily: "Семейство шрифтов",
    BackgroundColor: "Цвет фона",
    FontColor: "Цвет шрифта",
    PlayTime: "Время игры",
    Describe: "Описывать",
    HourMark: "Часовая метка",
    HourHand: "Стрелка часов",
    MinutesMark: "Минутная метка",
    MinutesHand: "минута",
    background: "Фоновая стрелка секундной стрелки",
    secondHand: "секунда",
    DateAndDay: "Дата и день",
    Display: "Дисплей",
    SelectTimeZone: "Выберите временную зону",
    Scale: "Масштаб",
    ConstrainProportions: "Ограничьте пропорции",
    EnterTheAnimation: "Введите анимацию",
    TheEntryTime: "Начальное время",
    Data: "дата",
    Time: "Время",
    ChineseCalendar: "Китайский календарь",
    Week: "Неделя",
    DateFormat: "Формат даты",
    Font: "Шрифт",
    Roll: "Рулон",
    FlipOver: "Переворачивание",
    Motionless: "Неподвижный",
    RollingDirection: "Изменяющееся направление",
    RollingVelocity: "Изменяющаяся скорость",
    FromLeftToRight: "Слева направо",
    FromRightToLeft: "справа налево",
    FromTopToBottom: "Сверху вниз",
    FromTheBottomUp: "С самого начала",
    Attribute: "Атрибут",
    AttendedMode: "Посещаемый режим",
    EndToEnd: "Из конца в конец",
    VolumeAdjust: "Регулировка громкости",
    Duration: "Продолжительность",
    Address: "Адрес",
    City: "Город",
    Temp: "температура",
    WindPower: "Ветер",
    Humidity: "влажность",
    DressingIndex: "Индекс одежды",
    PlayTheWay: "Играй по-своему",
    TimeFormat1: "00:00:00:00",
    TimeFormat2: "00D00H00M00S"
  }
}